class Block {
  constructor(el) {
    this.el = el;
    this.id = el.getAttribute('data-block-id');

    // check if block is inside page
    if (el.parentElement.parentElement.classList.contains('reader-page')) {
      this.page = el.parentElement.parentElement;
    } else if (el.parentElement.classList.contains('reader-page')) {
      this.page = el.parentElement;
    }
  }

  get height() {
    return this.el.offsetHeight;
  }

  get width() {
    return this.el.offsetWidth;
  }

  get top() {
    return this.el.offsetTop;
  }

  get bottom() {
    return this.el.offsetTop + this.el.offsetHeight;
  }
}

export default Block;
